import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ALLOWED_CONTENT_STATUSES } from '../constants';

import useLabelsSelectPropsQuery, {
	type useLabelsSelectPropsQuery$data,
	type useLabelsSelectPropsQuery$variables,
} from './__generated__/useLabelsSelectPropsQuery.graphql';

export function preloadLabels({ contentId }: { contentId: string }) {
	if (!contentId) {
		return Promise.resolve();
	}
	return query<useLabelsSelectPropsQuery$data, useLabelsSelectPropsQuery$variables>({
		query: useLabelsSelectPropsQuery,
		variables: {
			contentId,
			status: ALLOWED_CONTENT_STATUSES,
			refetchQuery: false,
		},
		fetchPolicy: 'network-only',
	});
}
